import { render } from "./DurationElement.vue?vue&type=template&id=1dfbb13d"
import script from "./DurationElement.vue?vue&type=script&lang=js"
export * from "./DurationElement.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__